import axios from 'axios';
import { isServerDownError, reportSuspectedOutage } from './serverStatus';

const api = axios.create({
  // baseURL: 'http://192.168.45.37:4000/api',     // Backend 주소(서버 운영시 변경)
  // baseURL: 'http://192.168.125.250:4000/api',     // Backend 주소(서버 운영시 변경)
  // baseURL: 'http://localhost:4000/api',     // Backend 주소(서버 운영시 변경)
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,                    // 세션 쿠키 포함
});

// 401 에러 시 로그인 페이지로 리다이렉트, 서버 무응답/게이트웨이 오류 시 점검 상태 확인
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isServerDownError(error)) {
      reportSuspectedOutage();
    } else if (error.response?.status === 401) {
      // 현재 경로가 로그인 페이지가 아닌 경우에만 리다이렉트
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

